import React, { useState, useEffect } from 'react';
import {useCollection} from '../../hooks/useCollection'
import ProjectList from "../../components/ProjectList";
import ProjectSort from '../../components/sortedValues/ProjectSort';
import './Dashboard.css';

const Dashboard = () => {
    const { documents, error } = useCollection('projects');

    const [sortBy, setSortBy] = useState(() => {
        const savedSort = localStorage.getItem('projectSortPreference');
        return savedSort || 'dueDate-asc';
    });  

    useEffect(() => {
        localStorage.setItem('projectSortPreference', sortBy);
      }, [sortBy]);


    return (
      <div className="dashboard">
        <div className="page-header">
          <h2 className="page-title">Pending Assignments</h2>
          <ProjectSort sortBy={sortBy} onSortChange={setSortBy} />
        </div>
        {error && <p className="error">{error}</p>}
        {documents && <ProjectList projects={documents} sortBy={sortBy} />}
      </div>
    );
  };
  
  export default Dashboard;